import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { toggleAddCreativeModal } from '../../../../../../slices/modals/reducer';
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { addNewImage } from '../../../../../../slices/campaigns/thunk';
import DropFileTable from '../../../Components/DropFileTable';
import UploadCampaign from '../../../Components/UploadCampaign';
import { setCampaignLoader } from '../../../../../../slices/campaigns/reducer';

function AddNewCreative({dropFileType = {}}) {
  const dispatch = useDispatch();

  const selectAddCreativeModal = createSelector((state) => state.Modal, (state) => state.addCreativeModal);
  const addCreativeModal = useSelector(selectAddCreativeModal);

  async function handleSubmit() {
    dispatch(setCampaignLoader(true));
    await dispatch(addNewImage());
    dispatch(toggleAddCreativeModal());
    dispatch(setCampaignLoader(false));
  }
  return (
    <Modal isOpen={addCreativeModal} toggle={() => dispatch(toggleAddCreativeModal())} centered size="lg">
      <ModalHeader className='p-3' toggle={() => dispatch(toggleAddCreativeModal())}>
        Add New
      </ModalHeader>
      <ModalBody className='px-3'>
        <UploadCampaign limits={dropFileType} />
        <DropFileTable />
      </ModalBody>
      <ModalFooter>
        <button className='btn btn-light' type='button' onClick={() => dispatch(toggleAddCreativeModal())}>Close</button>
        <button className='btn btn-success' type='button' onClick={handleSubmit}>Save</button>
      </ModalFooter>
    </Modal>
  )
}

export default AddNewCreative